var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c(
        "rbv-dropdown",
        {
          attrs: { "is-open": _vm.isOpen, "backdrop-style": "transparent" },
          on: { close: _vm.toggle },
        },
        [
          _c("div", { attrs: { slot: "toggler" }, slot: "toggler" }, [
            _c(
              "button",
              {
                staticClass: "rbButton",
                class: _vm.$style.toggler,
                on: { click: _vm.toggle },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
                _c("span", [_vm._v("Save Filters")]),
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: _vm.isOpen
                      ? _vm.$style.dropdownOpenArrow
                      : _vm.$style.dropdownArrow,
                  },
                  [_vm._v("arrow_drop_down")]
                ),
              ]
            ),
            _c("div", { staticClass: "rbTooltip simple" }, [
              _vm._v("Set current Filters as default"),
            ]),
          ]),
          _c(
            "div",
            {
              class: _vm.$style.dropdownContainer,
              attrs: { slot: "dropdown" },
              on: { click: _vm.toggle },
              slot: "dropdown",
            },
            [
              _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.$rbEmit({ name: "save" })
                    },
                  },
                },
                [_vm._v("To Current Travel Destination")]
              ),
              _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.$rbEmit({ name: "setDefaultFilters" })
                    },
                  },
                },
                [_vm._v("To All Travel Destinations in RFP")]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }